import Button from '@/components/Button';
import SubContainer from '@/components/Container/SubContainer';
import { usePasswordForm } from './usePasswordForm';
import { PasswordField } from './PasswordField';

export default function ProfilePassword() {
  const { isLoading, control, handleSubmit, page } = usePasswordForm();
  const {
    yourPasswordTitle,
    yourCurrentPasswordField,
    yourNewPasswordField,
    confirmYourPasswordField,
    confirmYourChangesCta,
  } = page?.profilePasswordSection || {};
  return (
    <SubContainer className="lg:!col-start-3 lg:mb-16">
      <form onSubmit={handleSubmit} className="flex cursor-pointer flex-col items-start gap-5">
        <h1 className=" text-sh-md font-bold">{yourPasswordTitle}</h1>

        <PasswordField name="currentPassword" label={yourCurrentPasswordField} control={control} />
        <PasswordField name="password" label={yourNewPasswordField} control={control} />
        <PasswordField name="passwordConfirmation" label={confirmYourPasswordField} control={control} />

        <Button theme="solid" type="submit" loading={isLoading} className=" mt-8">
          {confirmYourChangesCta}
        </Button>
      </form>
    </SubContainer>
  );
}
